module.exports = __webpack_public_path__ + "static/media/Click.3a105b1a.png";